import { refreshDynamicDataCache, createSignal, clearCachedPages } from '@avensia/excite';

export const [loginEvent] = createSignal();
export const [logoutEvent] = createSignal();
export const [registrationEvent] = createSignal();

function clearCachesOnLoginAndLogut() {
  clearCachedPages();
  refreshDynamicDataCache();
}

if (__BROWSER__) {
  loginEvent.on(() => clearCachesOnLoginAndLogut());
  logoutEvent.on(() => clearCachesOnLoginAndLogut());
  registrationEvent.on(() => clearCachesOnLoginAndLogut());
}